<template>
  <div v-title="'每日签到'" class="sign-in">
    <div class="panel-body">
      <div class="head">
        <img src="~assets/SignIn/bac_01.png" onClick="return false">
        <img src="~assets/SignIn/bac_02.png" onClick="return false">
        <img src="~assets/SignIn/bac_03.png" onClick="return false">
        <img src="~assets/SignIn/bac_04.png" onClick="return false">
        <img src="~assets/SignIn/bac_05.png" onClick="return false">
        <img src="~assets/SignIn/bac_06.png" onClick="return false">
      </div>
      
      <div class="info">
        <!-- 绑定按钮 -->
        <p class="rebind returntop">
          <img id="not_bound" src="~assets/SignIn/ghbd.png" @click="rebind">
        </p>
        <!--立即签到按钮-->
        <p class="returntop anniu">
          <img v-if="hasSignin && getRwFail" :src="require('../../assets/SignIn/btn.png')" id="sign"
            @click="retryLottery()">
          <img v-if="hasSignin && !getRwFail" :src=" require('../../assets/SignIn/btn8.png')" id="sign">
          <img v-if="!hasSignin" :src="require('../../assets/SignIn/btn.png')" id="sign" @click="toSignin()">
          <span class="text">您已签到{{signDays}}天</span>
        </p>

        <!--  /立即签到按钮-->

        <!-- 签到礼品内容 -->
        <div class="detail">
          <img class="title" src="~assets/SignIn/bt1.png" onClick="return false">
          <ul>
            <li>
              <img src="~assets/SignIn/qdlp1.png" onClick="return false">
            </li>
            <li>
              <img src="~assets/SignIn/qdlp2.png" onClick="return false">
            </li>
            <li>
              <img src="~assets/SignIn/qdlp3.png" onClick="return false">
            </li>
            <li>
              <img src="~assets/SignIn/qdlp4.png" onClick="return false">
            </li>
          </ul>
        </div>
        <!-- /签到礼品内容 -->

        <!--活动规则-->
        <div class="rule"><img class="title" src="../../assets/SignIn/bt2.png" onClick="return false"></div>
        <div class="rules">
          <p>
            <img src="../../assets/SignIn/dian.png" onClick="return false"> 用户需要绑定和平精英
            <span>公众号（txhpjy2019）</span>后才可参与签到活动
          </p>
          <p>
            <img src="../../assets/SignIn/dian.png" onClick="return false"> 每日签到除累积到特殊天数外，可获得
            <span>金币*158</span>。累计签到达到特殊天数当天可获得特殊奖励
          </p>
          <p>
            <img src="../../assets/SignIn/dian.png" onClick="return false"> 活动期间，每个微信账号每日只能签到一次
          </p>
          <p>
            <img src="../../assets/SignIn/dian.png" onClick="return false"> 本活动以累计签到的形式进行，累计签到满7次将清空重计
          </p>
          <p>
            <img src="../../assets/SignIn/dian.png" onClick="return false"> 奖励直接发放至用户的游戏内邮箱，如因系统延迟未收到奖励，请退出重新登录领取
          </p>

        </div>
        <!-- /活动规则-->
      </div>

      <!--未绑定弹出框-->
      <div class="popup" id="Unbound">
        <div class="mask close"></div>
        <div class="event one">
          <p class="close"><img src="~assets/SignIn/close.png" onClick="return false" @click="toclose"></p>
          <p class="title"><img src="~assets/SignIn/title1.png" onClick="return false"></p>
          <a class="jr" href="/"><img src="~assets/SignIn/btn6.png" onClick="return false" @click="tobind"></a>
        </div>
      </div>
      <!-- /弹出框-->

      <!--绑定战场账号-->
      <div class="popup">
        <div class="bindingContent"></div>
      </div>
      <!-- /弹出框-->

      <!--绑定成功弹出框-->
      <div class="popup" id="bindingwin">
        <div class="mask close"></div>
        <div class="event one">
          <p class="close"><img src="~assets/SignIn/close.png" onClick="return false" @click="toclose"></p>
          <p class="title"><img src="~assets/SignIn/title3.png" onClick="return false"></p>
          <a class="jr" href="/"><img src="~assets/SignIn/btn3.png" onClick="return false" @click="toclose"></a>
        </div>
      </div>
      <!-- /弹出框-->

      <!--每日奖励弹出框-->
      <div class="popup" id="sign_success">
        <div class="mask close"></div>
        <div class="event three" :style="{background: 'url(' + bgimg + ') no-repeat', backgroundSize: bgSize}">
          <p class="close"><img style="top:0rem" src="~assets/SignIn/close.png" @click="toclose">
          </p>
          <p class="gif">
            <ul class="qdxf">
              <li :class="qdNum" v-for="(item, index) in SignList" :key="index">{{item}}</li>
            </ul>
          </p>
          <p class="Lotterypoetry" v-html="FortuneJSON.Lotterypoetry">{{FortuneJSON.Lotterypoetry}}</p>
          <p class="Lottery" v-for="(item, idx) in popList[showDays].text" :key="idx">
            <img :src="popList[showDays].rwImg" onClick="return false">
            <span>{{item.name}}</span>
          </p>
          <img class="receive" src="~assets/SignIn/btn1.png" @click="toclose">

        </div>
      </div>
      <!-- /弹出框-->

      <!--已签到明天再来弹出框-->
      <div class="popup" id="to-morrow">
        <div class="mask close"></div>
        <div class="event one">
          <p class="close"><img src="~assets/SignIn/close.png" onClick="return false" @click="toclose"></p>
          <p class="title big"><img src="~assets/SignIn/title9.png" onClick="return false"></p>
          <a class="jr" href="https://gp.qq.com/d/index.html"><img src="~assets/SignIn/btn4.png"></a>

          <p class="des">更多奖励请继续关注公众号，
            <br>或者前往福利中心领取更多福利！</p>
        </div>
      </div>
      <!-- /弹出框-->

      <!--未找到信息弹出框-->
      <div class="popup" id="no-information">
        <div class="mask close"></div>
        <div class="event one">
          <p class="close"><img src="~assets/SignIn/close.png" onClick="return false" @click="toclose"></p>
          <p class="title nodata"><img src="~assets/SignIn/title10.png" onClick="return false"></p>
          <a class="jr" href="/"><img src="~assets/SignIn/btn3.png" onClick="return false" @click="getinformation"></a>
          <p class="des">更多奖励请继续关注公众号，
            <br>或者前往福利中心领取更多福利！</p>
        </div>
      </div>
      <!-- /弹出框-->

      <!--重绑成功弹出框-->
      <div class="popup" id="rebindingwin">
        <div class="mask close"></div>
        <div class="event one">
          <p class="close"><img src="~assets/SignIn/close.png" onClick="return false" @click="toclose"></p>
          <p class="title"><img src="~assets/SignIn/title11.png" onClick="return false"></p>
          <a class="jr" href="/"><img src="~assets/SignIn/btn3.png" onClick="return false" @click="toclose"></a>
        </div>
      </div>
      <!-- /弹出框-->

    </div>

  </div>
</template>

<script>
  import wxMethods from "@/utils/wxMethods";
  import mtaInitial from "@/utils/mtaInitial";
  import Http from "@/utils/Http";

  import Fortune from "./Fortune.json";
  import {
    log
  } from 'util';
  export default {
    name: "SignIn",
    data() {
      return {
        isBind: false,
        signDays: 0,
        qdNumClass: "",
        hasSignin: false,
        showDialog2: false,
        hasgetRole: false,
        getRwFail: false,
        title: "",
        isClick: false,
        bgimg: "",
        bgSize: "",
        FortuneJSON: [],
        SignList: [],
        retrying: false,
        gameTool: null,
        popList: {
          1: {
            titleImg: require("@/assets/SignIn/title4.png"),
            rwImg: require("@/assets/SignIn/tu1.png"),
            text: [{
              name: "金币 x 158",
              desc: ""
            }]
          },
          3: {
            titleImg: require("@/assets/SignIn/title5.png"),
            rwImg: require("@/assets/SignIn/tu2.png"),
            text: [{
              name: "金币 x 288",
              desc: ""
            }]
          },
          5: {
            titleImg: require("@/assets/SignIn/title6.png"),
            rwImg: require("@/assets/SignIn/tu3.png"),
            text: [{
              name: "方形眼镜（黄）（3天）×1",
              desc: ""
            }]
          },
          7: {
            titleImg: require("@/assets/SignIn/title7.png"),
            rwImg: require("@/assets/SignIn/tu4.png"),
            text: [{
              name: "黑色ROCK长袖T恤（3天）×1",
              desc: ""
            }]
          }
        }
      };
    },
    mixins: [wxMethods],
    computed: {
      showDays() {
        if (this.signDays === 3 || this.signDays === 5 || this.signDays === 7) {
          return this.signDays;
        }
        return 1;
      },
      qdNum() {
        if (this.SignList.length == 6) {
          this.qdNumClass = 'qd6'
        } else if (this.SignList.length < 2) {
          this.qdNumClass = 'qd1'

        } else if (2 < this.SignList.length <= 5) {
          this.qdNumClass = 'qd3'
        }
        return this.qdNumClass;

      },
    },
    created() {
      this.signInId = this.$route.query.id;
      this.wxHideMenu();
      this.initRole();
      this.getRole()
    },

    mounted() {
      mtaInitial(
        process.env.VUE_APP_MTA_SIGNIN_SID,
        process.env.VUE_APP_MTA_SIGNIN_CID
      );
    },

    methods: {
      initRole() {
        this.gameTool = new GameTools({
          game: 'cjm',
          allowPlatForm: ['wx'],
          loginType: 'wx',
        });
      },
      getRole() {
        this.isClick = true;
        if (this.binding) return;
        this.binding = true;
        this.gameTool.getRole(process.env.VUE_APP_GAME).then(res => {
          if (res.hasRole) {
            this.isBind = true;
            this.binding = false;
            this.isClick = false;
            this.checkSign();
          } else {
            const modal = new GameModal({
              gameTool: this.gameTool,
              game: process.env.VUE_APP_GAME,
              serverSelect: res.serverSelect,
              confirmText: " ",
              showClose: true
            });

            modal.show();
            this.binding = false;
            this.isClick = false;
            modal.afterBind = isBinded => {
              if (isBinded) {
                this.isBind = true;
                this.checkSign();
                modal.hide();
                $("#bindingwin").show();
              } else {
                modal.hide();
                $("#no-information").show();
                this.hasgetRole = true;
              }
            };

            modal.afterUnBind = (isUnBinded) => {
              if (isUnBinded) {
                modal.hide()
                this.isBind = false
                alert('解绑成功')
              } else {
                alert('解绑失败，请重试')
              }
            }
          }
        });
      },
      getinformation() {
        $("#no-information").hide();
        if (this.hasgetRole) {
          this.getRole();
        } else {
          this.rebind();
        }
      },
      rebind() {
        this.isClick = true;
        if (this.rebinding) return;
        this.rebinding = true;
        this.gameTool.getServerSelect(process.env.VUE_APP_GAME).then(serverSelect => {
          const modal = new GameModal({
            gameTool: this.gameTool,
            game: process.env.VUE_APP_GAME,
            serverSelect,
            confirmText: " ",
            showClose: true
          });

          modal.show();
          this.rebinding = false;
          this.isClick = false;

          modal.afterBind = isBinded => {
            if (isBinded) {
              this.isBind = true;
              modal.hide();
              $("#rebindingwin").show();
            } else {
              modal.hide();
              $("#no-information").show();
              this.hasgetRole = false;
            }
          };

          modal.afterUnBind = (isUnBinded) => {
            if (isUnBinded) {
              modal.hide()
              this.isBind = false
              alert('解绑成功')
            } else {
              alert('解绑失败，请重试')
            }
          }
        });
      },

      checkSign() {
        Http.get({
            path: "awp-signin/check",
            params: {
              id: this.signInId
            }
          })
          .then(res => {
            if (res.code === 0) {
              this.signDays = res.result.signin_count;
              if (res.result.today_signin === 1) {
                this.hasSignin = true;
                if (res.result.lottery.status === 2) {
                  this.getRwFail = true;
                }
              }
            } else {
              alert(res.msg);
            }
          })
          .catch(err => {
            console.warn("error", err);
            alert(err.msg);
          });
      },
      signin() {
        if (this.loading) return;
        this.loading = true;
        Http.post({
            path: "awp-signin/register",
            params: {
              id: this.signInId
            }
          })
          .then(res => {
            this.loading = false;
            if (res.code === 0) {
              this.hasSignin = true;
              this.signDays = res.result.signin_count;
              const lotteryStatus = res.result.lottery.status;
              if (lotteryStatus === 1) {
                this.GetFortune();
                $("#sign_success").show();
              } else if (lotteryStatus === 2) {
                // 发奖失败
                this.getRwFail = true;
                alert("签到成功，发奖失败，请再次点击领取");
              } else if (lotteryStatus === 3) {
                // 本次无奖励
                alert(res.result.lottery.hint_no_reward);
              } else {
                alert(res.msg);
              }
            } else {
              this.hasSignin = false;
              alert(res.msg);
            }
          })
          .catch(err => {
            this.loading = false;
            console.warn("error", err);
            alert(err.msg);
          });
      },

      toSignin() {
        if (this.isClick) return;
        if (this.isBind) {
          this.signin();
        } else {
          $("#Unbound").show();
        }
      },
      // 获取签文
      GetFortune() {
        const FortuneJSON = [];
        var randomNum = parseInt(78 * Math.random());
        for (var i in Fortune) {
          if (i == randomNum) {
            this.FortuneJSON = Fortune[i];
          }
        }
        var s = this.FortuneJSON.Sign;
        const SignList = [];
        for (var i in s) {
          SignList.push(s[i])
        }
        this.SignList = SignList;
        this.rwLists(this.FortuneJSON.Sign.length);
      },
      rwLists(length) {
        switch (length) {
          case 1:
            this.bgimg = require("../../assets/SignIn/lotwrite1.png");
            this.bgSize = 'contain';
            break
          case 2:
            this.bgimg = require("../../assets/SignIn/lotwrite2.png");
            this.bgSize = 'contain';
            $('.qdxf').css('padding', '0 28%')
            break
          case 3:
            this.bgimg = require("../../assets/SignIn/lotwrite3.png");
            this.bgSize = 'contain';
            $('.qdxf').css('padding', '0 23%')
            break
          case 4:
            this.bgimg = require("../../assets/SignIn/lotwrite4.png");
            this.bgSize = 'contain';
            $('.qdxf').css('padding', '0 14%')
            break
          case 5:
            this.bgimg = require("../../assets/SignIn/lotwrite5.png");
            this.bgSize = 'contain';
            $('.qdxf').css('padding', '0 5%')

            break
          case 6:
            this.bgimg = require("../../assets/SignIn/lotwrite6.png");
            this.bgSize = 'contain';
            $('.qdxf').css('padding', '0 7%')

            break
        }
      },
      // 重新领取奖励
      retryLottery() {
        if (this.retrying) return;
        this.retrying = true;
        Http.post({
            path: "awp-signin/retryLottery",
            params: {
              id: this.signInId
            }
          })
          .then(res => {
            this.retrying = false;
            if (res.code === 0) {
              const rwStatus = res.result.status;
              if (rwStatus === 1) {
                this.GetFortune();
                $("#sign_success").show();
                this.getRwFail = false;
                this.hasSignin = true;
              } else if (rwStatus === 2) {
                alert("发奖失败，请再次点击领取");
              } else if (rwStatus === 3) {
                alert("无奖励");
              }
            } else {
              alert(res.msg);
            }
          })
          .catch(err => {
            this.retrying = false;
            alert(err.msg);
          });
      },
      tobind() {
        $("#Unbound").hide();
        this.getRole();
      },
      toclose() {
        $(".popup").hide();
      },
    }
  };
</script>

<style src="./SignIn.scss" lang="scss"></style>